import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Form, Select, Input, DatePicker, Tooltip, Radio, Checkbox, Button, Space, Popconfirm } from 'antd';
import Header from "../../components/Header"
import Footer from '../../components/Footer';
import api from '../../services/api';
import { message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao';
import modalStatus from '../../redux/reducers/permissao';
import Permissao from '../Permissao';
import ModalEditarServico from './ModalEditarServico';
import ModalNovoServico from './ModalNovoServico';

interface ServicoProps {
    permissao?: any
    modalStatus?: any,
    setNovoServicoModal?: any,
    setEditarServicoModal?: any
}

const Servico: React.FC<ServicoProps> = (prop) => {
    let servico: any;
    let servicos: any[] = [];
    const [servicoResponse, setServicoResponse] = useState<any[]>();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;

    useEffect(() => {
        Buscar({ servicoID: 0, descricao: "" });
    }, [])

    useEffect(() => {
        Buscar({ servicoID: 0, descricao: "" });
    }, [prop.modalStatus[0]])

    const novoServico = async (values: any) => {
        prop.setNovoServicoModal(true);
    }
    const editarServico = (values: any) => {
        prop.setEditarServicoModal(true, values)
    }

    const ativarDesativarServico = (servico: any, ehAtivo: boolean) => {
        setLoading(true);
        api.put(`Servico`, {
            ServicoID: servico.servicoID,
            Descricao: servico.descricao,
            Ativo: ehAtivo,
        })
        .then((response:any) => {
            if (response.data.valido) {
                message.success(`Serviço ${ehAtivo ? 'ativo' : 'desativado'} com sucesso`)
            }
            else {
                message.error(response.data.error)
            }
        }).catch(() => {
            message.error('Falha na requisição');
        }).finally(() => {
            Buscar({ servicoID: 0, descricao: "" });
            setLoading(false);
        })
    }

    const Buscar = async (values: any) => {
        setLoading(true);
        await api.post(`Servico/getcomfiltros`, {
            servicoID: 0,
            Descricao: values.descricao,
            Ativo: values.ativo == null ? null : values.ativo === "true" ? true : false,
        })
        .finally(()=> setLoading(false))
            .then((response: any) => {
                if (response.status === 200) {
                    response.data.forEach((e: any) => {
                        servico = {
                            key: e.servicoID,
                            servicoID: e.servicoID,
                            descricao: e.descricao,
                            ativo: e.ativo,
                        }
                        servicos.push(servico);
                    });
                    setServicoResponse(servicos);
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')            
            });      
    };

    const columns: ColumnsType<any> = [
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            width: '60%'
        },
        {
            title: 'Ativo',
            dataIndex: 'ativo',
            width: '20%',
            render: (text: any, record: any) => (<p>{record.ativo ? 'Sim' : 'Não'}</p>)

        },
        {
            title: 'Ações',
            key: 'action',
            render: (text, record: any) => (

                <Space size="middle">
                    {prop.permissao[0].permissaoAcesso?.editar === true ?
                        <Button htmlType="button" onClick={() => { editarServico(record) }}>Editar</Button>
                        : null}
                    {
                        record.ativo === true ?
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.servicoID} placement="top" title="Você tem certeza que deseja desativar esse Serviço?" onConfirm={() => { ativarDesativarServico(record, false); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.servicoID} danger >  Desativar </Button>
                                </Popconfirm>
                                : null
                            :
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.servicoID} placement="top" title="Você tem certeza que deseja ativar esse Serviço?" onConfirm={() => { ativarDesativarServico(record, true); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.servicoID}  >  Ativar </Button>
                                </Popconfirm>
                                : null
                    }

                </Space>
            ),
            fixed: 'right' as 'right',
        }
    ];


    return (
        <div>
            <Header></Header>
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Spin spinning={false}>
                        <Form onFinish={Buscar}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"
                        >
                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Descrição"
                                        name="descricao"
                                    >
                                        <Input placeholder="Informe a descrição do serviço" />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Ativo"
                                        name="ativo"
                                        initialValue={null}
                                    >
                                        <Select placeholder="Ativo">
                                            <Option value="null">Selecione</Option>
                                            <Option value="true">Sim</Option>
                                            <Option value="false">Não</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item className="buttons">
                                {prop.permissao[0].permissaoAcesso?.cadastrar === true ?
                                    <Button className="button-novo" onClick={novoServico} type="ghost" htmlType="button">
                                        Novo Serviço
                                    </Button>
                                    : null}
                                <Button className="button-filtrar" type="primary" htmlType="submit">
                                    Filtrar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Spin>
                </fieldset>
                <br />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Table loading={loading} columns={columns} dataSource={servicoResponse} rowKey={"servicoID"} bordered={true}></Table>
                    </Col>
                </Row>
            </div>
            <Footer></Footer>
            <ModalEditarServico></ModalEditarServico>
            <ModalNovoServico></ModalNovoServico>
        </div>

    );
}
const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(Servico);